(function(){
     'use strict';

     angular
        .module('appback')
        .factory('CentroService', CentroService);

    CentroService.$inject = ['$http'];

    function CentroService($http){

        var service= {
           getInfoCentro:getInfoCentro
        };

        return service;
 		function getInfoCentro(centro_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/centro/getinfocentro', { params : { centro_id:centro_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      
    }
})();